{
	"termsAndConditions": {
		"title": "Terms & Conditions",
		"submitTitle": "Accept & Continue to Privacy Policy"
	},
	"privacyPolicy": {
		"title": "Privacy Policy",
		"submitTitle": "Accept & Close",
		"backTitle": "Back"
	}
}
